export const REPORT_TIMEFRAME_TYPE_NO_LIMIT: string = 'no-limit';
export const REPORT_TIMEFRAME_TYPE_CUSTOM: string = 'custom';
